module.exports = __webpack_public_path__ + "img/dongji_ps_29.8dbe04d8.jpg";